module.exports = __webpack_public_path__ + "media/images/Company_logo-2f296d94f40bf40b371c52243e27794c.png";